// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"27":"87e01990","46":"542eaa8f","93":"0c83e803","216":"372ab6c5","280":"d7d86861","350":"120bbf5b","373":"60fa96b1","489":"1f29e6a5","666":"043d28f3","681":"7467c56f","816":"ac212339","862":"9505af38","959":"157e897f"}[chunkId] + ".chunk.js";
};